import React from "react";
import "./skills.css";
const Skills = () => {
	return (
		<section className="skills" id="skills">
			<div className="pro">
				<span className="style"></span>
				<span className="style"></span>
				<span className="style"></span>
				<div>
					<h2>Skills:</h2>
					<p>HTML</p>
					<p>CSS</p>
					<p>Javascript</p>
					<p>React</p>
					<p>Bootstrap</p>
					<p>Tailwindcss</p>
					<p>JQuriey</p>
					<p>ThreeJS</p>
				</div>
				<div>
					<p>npm</p>
					<p>Sass</p>
					<p>Pug.js</p>
					<p>Gulp.js</p>
					<p>Jest.js</p>
					<p>Git,Github</p>
					<p>Command line</p>
				</div>
			</div>
			<div class="pro">
				<span class="style"></span>
				<span class="style"></span>
				<span class="style"></span>
				<h2>🎨Other related skills:</h2>
				<p>Figma</p>
				<span>UI/UX design tool</span>
				<p>Blender</p>
				<span>3D modeling program</span>
				<p>GIMP</p>
				<span>Photo editing program</span>
			</div>
			<div className="pro other">
				<span className="style"></span>
				<span className="style"></span>
				<span className="style"></span>
				<p>🎓Bachelor of Computer Science from Algadarif University.</p>
			</div>
		</section>
	);
};

export default Skills;
